import React, { useState } from 'react';
import { FaShareAlt, FaCopy, FaCheck, FaTimes, FaShieldAlt } from 'react-icons/fa';

interface GenerarLinkModalProps {
  isOpen: boolean;
  onClose: () => void;
  numeroEntrada: string;
  urlTransferencia: string;
  fechaExpiracion?: string;
}

export const GenerarLinkModal: React.FC<GenerarLinkModalProps> = ({
  isOpen,
  onClose,
  numeroEntrada,
  urlTransferencia,
  fechaExpiracion
}) => {
  const [copiado, setCopiado] = useState(false);

  if (!isOpen) return null;

  const handleCopiar = async () => {
    try {
      await navigator.clipboard.writeText(urlTransferencia);
      setCopiado(true);
      setTimeout(() => setCopiado(false), 3000);
    } catch (err) {
      console.error('Error al copiar enlace:', err);
    }
  };

  return (
    <div 
      className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-[999999]"
      onClick={onClose}
    >
      <div 
        className="bg-white dark:bg-boxdark rounded-2xl max-w-md w-full shadow-2xl border border-slate-100 dark:border-strokedark overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header con insignia corporativa de alto contraste */}
        <div className="bg-primario-azul-900 px-6 py-4 flex items-center justify-between text-white">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center text-white shadow-sm flex-shrink-0">
              <FaShareAlt className="w-5 h-5 text-white" />
            </div>
            <div>
              <h3 className="font-bold text-base text-white">Transferir Entrada</h3>
              <p className="text-xs text-blue-200">Ticket #{numeroEntrada}</p>
            </div>
          </div>
          <button 
            onClick={onClose}
            aria-label="Cerrar modal"
            className="p-1.5 rounded-full hover:bg-white/20 text-white transition duration-150"
          >
            <FaTimes className="w-5 h-5" />
          </button>
        </div>

        <div className="p-6 space-y-4">
          <p className="text-xs text-slate-600 dark:text-slate-300 leading-relaxed">
            Compartí este enlace de transferencia con el nuevo destinatario. Al ingresar, el destinatario podrá completar sus datos y transferir la entrada a su nombre.
          </p>

          <div className="p-3 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-700/50 rounded-xl flex items-start space-x-2.5">
            <FaShieldAlt className="text-amber-600 dark:text-amber-400 mt-0.5 flex-shrink-0" />
            <div className="text-[11px] text-amber-800 dark:text-amber-300 leading-normal">
              <strong>Enlace One-Shot Seguro:</strong> El enlace expira automáticamente al ser utilizado o el {fechaExpiracion ? new Date(fechaExpiracion).toLocaleString() : 'en 48 hs'}.
            </div>
          </div>

          <div className="space-y-1.5">
            <label className="block text-xs font-bold text-slate-700 dark:text-slate-200">Enlace de Transferencia</label>
            <div className="flex items-center space-x-2">
              <input
                type="text"
                readOnly
                value={urlTransferencia}
                className="w-full px-3 py-2 text-xs bg-slate-50 dark:bg-meta-4 border border-slate-200 dark:border-strokedark rounded-xl text-black dark:text-white font-mono select-all focus:outline-none"
              />
              <button
                type="button"
                onClick={handleCopiar}
                className={`px-4 py-2 text-xs font-bold rounded-xl transition duration-150 flex items-center space-x-1.5 flex-shrink-0 shadow-sm ${
                  copiado 
                    ? 'bg-emerald-600 text-white' 
                    : 'bg-primario-celeste-800 hover:bg-primario-azul-900 text-white'
                }`}
              >
                {copiado ? <FaCheck className="w-3.5 h-3.5" /> : <FaCopy className="w-3.5 h-3.5" />}
                <span>{copiado ? 'Copiado' : 'Copiar'}</span>
              </button>
            </div>
          </div>

          <div className="pt-4 border-t border-slate-100 dark:border-strokedark flex justify-end">
            <button
              type="button"
              onClick={onClose}
              className="px-5 py-2 text-xs font-bold text-slate-700 dark:text-slate-200 bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 rounded-xl transition duration-150"
            >
              Listo
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
